import styled from "styled-components";
import Colors from "../../../../../Constants/Colors";

const DashBoardContainer = styled.div`
  width: 100%;
  max-width: 22rem;
  min-width: 22rem;
  height: 100%;
  min-height: 13rem;
  padding: 1.25rem;
  border-radius: 0.75rem;
  border: 2px solid transparent;
  box-shadow: 1px 1px 6px 1px rgba(0, 0, 0, 0.2);
  background-color: ${Colors.white};
  cursor: pointer;
  &:hover {
    border: 2px solid ${Colors.primary};
  }

  @media (max-width: 576px) {
    max-width: 100%;
    min-width: 100%;
  }
`;

const SubmitButton = styled.button`
  position: fixed;
  right: 1rem;
  bottom: 1rem;
  padding: 1rem 1.25rem;
  font-family: Poppins, serif;
  font-size: 0.875rem;
  color: ${(props) => props.color || Colors.white};
  border-radius: 0.75rem;
  background-color: ${(props) => props.backgroundColor || Colors.primary};
  transition: background-color 0.4s ease;

  &:hover {
    background-color: ${Colors.hoverButtonColor};
  }
  &:disabled {
    opacity: 0.5 !important;
  }
`;

export default {
  DashBoardContainer,
  SubmitButton,
};
